package org.hs_soft.runmynesto.domain.model.home.options.virtual_card

import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings

enum class CustomerCardInfoEnum {
    COMPANY_NAME,
    EMAIL_COMPANY,
    DESIGNATION,
    DESCRIPTION,
    TITLE_FIELD_1,
    TITLE_1,
    TITLE_FIELD_2,
    TITLE_2,
    TITLE_CONTACT,
    TELEPHONE_NUMBER,
    TITLE_WEBSITE,
    WEBSITE;

    @Composable
    fun getTitleShown(): String {
        val strings = Strings.current()
        return when (this) {
            COMPANY_NAME -> strings.companyName
            EMAIL_COMPANY -> strings.emailCompany
            DESIGNATION -> strings.name
            DESCRIPTION -> strings.description
            TITLE_FIELD_1 -> strings.titleField1
            TITLE_1 -> strings.title1
            TITLE_FIELD_2 -> strings.titleField2
            TITLE_2 -> strings.title2
            TITLE_CONTACT -> strings.titleContact
            TELEPHONE_NUMBER -> strings.telephoneNumber
            TITLE_WEBSITE -> strings.titleWebsite
            WEBSITE -> strings.website
        }
    }

    val titleShown: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                COMPANY_NAME -> strings.companyName
                EMAIL_COMPANY -> strings.emailCompany
                DESIGNATION -> strings.name
                DESCRIPTION -> strings.description
                TITLE_FIELD_1 -> strings.titleField1
                TITLE_1 -> strings.title1
                TITLE_FIELD_2 -> strings.titleField2
                TITLE_2 -> strings.title2
                TITLE_CONTACT -> strings.titleContact
                TELEPHONE_NUMBER -> strings.telephoneNumber
                TITLE_WEBSITE -> strings.titleWebsite
                WEBSITE -> strings.website
            }
        }

    val title: String
        get() = when (this) {
            COMPANY_NAME -> ApiUtils.Field.VirtualCardFields.ISSUER_NAME
            EMAIL_COMPANY -> ApiUtils.Field.VirtualCardFields.ISSUER_EMAIL
            DESIGNATION -> ApiUtils.Field.VirtualCardFields.PROGRAM_NAME
            DESCRIPTION -> ApiUtils.Field.VirtualCardFields.ACCOUNT_ID_LABEL
            TITLE_FIELD_1 -> ApiUtils.Field.VirtualCardFields.REWARDS_TIER_LABEL
            TITLE_1 -> ApiUtils.Field.VirtualCardFields.REWARDS_TIER
            TITLE_FIELD_2 -> ApiUtils.Field.VirtualCardFields.SECONDARY_REWARDS_TIER_LABEL
            TITLE_2 -> ApiUtils.Field.VirtualCardFields.SECONDARY_REWARDS_TIER
            TITLE_CONTACT -> ApiUtils.Field.VirtualCardFields.PHONE_DESCRIPTION
            TELEPHONE_NUMBER -> ApiUtils.Field.VirtualCardFields.PHONE_LINK
            TITLE_WEBSITE -> ApiUtils.Field.VirtualCardFields.HOME_PAGE_DESCRIPTION
            WEBSITE -> ApiUtils.Field.VirtualCardFields.HOME_PAGE_LINK
        }
}